import React from 'react';
import {Flex, Form, Card, Next, List, Clarity, Slider} from 'components';
import {map, useNamedSelector} from 'helpers';

export function LifeChart() {
  const values = useNamedSelector('clarity.realityCheck');
  return (
    <Form initialValues={values} onChange={Clarity.RealityCheck.save}>
      <p>How happy / satisfied are you with the following aspects of your life?</p>
      <Card medium className="small-spacing">
        <List>
          { map(Clarity.RealityCheck.fields, ( label, name ) =>
            <div key={name}>
              <Flex justified>
                <b>{ label }</b>
                <Clarity.RealityCheck.Label name={name} />
              </Flex>
              <Slider min={1} max={10} filled="colored" name={name} />
            </div>
          ) }
        </List>
      </Card>
      <p className="medium-spacing text-center">
        <Next />
      </p>
    </Form>
  );
}
